import styled from 'styled-components'
import { color } from '../../../GlobalStyle'
import { breakpoints } from '../../../MediasQueries'

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2vh;
`
export const AreaCharts = styled.div`
  height: 270px;
  display: flex;
  margin-top: 20px;

  div {
    width: 100%;
  }
`
export const PieCharts = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
`
export const Box = styled.div`
  padding: 10px;

  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.background};
  -webkit-box-shadow: 0 0 30px rgb(8 21 66 / 10%);
  box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  width: ${(props) => props.width};
  border-radius: 7px;
`
export const PeriodSetDiv = styled.div`
  display: flex;

  button:nth-child(1) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  button:nth-child(3) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  input {
    text-align: center;
    font-weight: bold;
    width: 160px;
    background: #fff;
    border: 1px solid ${color.brand};
  }
`
export const Periods = styled.div`
  display: flex;
  width: 300px;
  button:nth-child(1) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  button:nth-child(2) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  button:nth-child(3) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`

export const GridLayout = styled.div`
  display: grid;

  grid-template-columns: repeat(8, 1fr);

  gap: 20px;

  p {
    font-weight: bold;
    font-size: 19px;
    padding: 12px 6px;

    button {
      float: right;
      margin-left: auto;
    }
  }

  .item1 {
    grid-column: span 8;
  }
  .item1-1 {
    grid-column: span 2;
  }

  .item3-1 {
    grid-column: span 2;
  }
  .item2 {
    grid-column: span 3;
  }
  .item3 {
    grid-column: span 3;
  }

  @media (max-width: ${breakpoints.sm}) {
    .item1 {
      grid-column: span 10;
    }
    .item1-1 {
      grid-column: span 10;
    }

    .item3-1 {
      grid-column: span 10;
    }
    .item2 {
      grid-column: span 10;
    }

    .item3 {
      grid-column: span 10;
    }
  }
`
